module.exports = __webpack_public_path__ + "static/media/benefits2.169aa0e2.webp";